import { render, staticRenderFns } from "./bookinproblem.vue?vue&type=template&id=8e8a1bbc"
import script from "./bookinproblem.vue?vue&type=script&lang=js"
export * from "./bookinproblem.vue?vue&type=script&lang=js"
import style0 from "./bookinproblem.vue?vue&type=style&index=0&id=8e8a1bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports